import { Badge } from '@/components/ui/badge';

/**
 * NQ P/L badge — green/red pill driven by the sign of a value. Shared primitive
 * used in positions tables, stat cards, comparison rows.
 */
export function PLBadge({ value, children }: { value: number; children: React.ReactNode }) {
  return <Badge variant={value >= 0 ? 'positive' : 'negative'}>{children}</Badge>;
}
